<div>
  <app-navbar></app-navbar>
  <router-outlet />
  <app-footer></app-footer>
</div>
